import { CartLineEdge, EmbarkCart } from 'shopify-buy';
import { LineItem } from './LineItem';
import React from 'preact/compat';
import { Recommendations } from './Recommendations';
import { ValueProps } from './ValueProps';

interface Props {
  cart: EmbarkCart | null;
  fetchItems: () => Promise<void>;
  valueProps: string[];
}
export const DrawerBody: React.FC<Props> = ({
  cart,
  fetchItems,
  valueProps,
}) => {
  return (
    <div className="cart-drawer__content">
      <div className="cart-drawer__items">
        {cart?.lines.edges.map((item: CartLineEdge) => (
          <LineItem
            item={item.node}
            onChange={fetchItems}
            key={item.node?.id}
          />
        ))}
      </div>
      <div id="cart-page__offer" className="cart-drawer__offer"></div>
      <div className="cart-drawer__value-props">
        <ValueProps props={valueProps} />
      </div>
      <div className="cart-drawer__recommendations">
        {cart && <Recommendations cart={cart} onChange={fetchItems} />}
      </div>
    </div>
  );
};
